




























import Vue from 'vue'
import { mapGetters } from 'vuex'

export default Vue.extend({
  computed: {
    ...mapGetters({
      currentDealer: 'dealers/currentDealer',
      currentMake: 'makes/currentMake',
      bannerImages: 'dealers/bannerImages',
      loading: 'dealers/loading'
    })
  }
})
